module.exports = __webpack_public_path__ + "img/mostly_clear_day.689ef5f0.svg";